import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import Amplify from "aws-amplify";
import config from "./config";


Amplify.configure({
  Auth: {
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
	region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
	mandatorySignIn: false
	,oauth: config.oauth
  },
  Analytics: {
    // OPTIONAL - disable Analytics if true
    disabled: false
  },
  API: {
    endpoints: [
      {
        name: "books",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    ]
  }
  , Logger: {LOG_LEVEL : 'DEBUG'}
});



ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js